import { useState, useEffect  } from 'react';
import { useUI }      from '../../context/UIContext';
import { useCart }    from '../../context/CartContext';
import { useCurrency} from '../../context/CurrencyContext';
import { validatePromo, placeOrder } from '../../lib/api';
import { buildOrderMessage }         from '../../lib/whatsapp';

export default function CheckoutDrawer() {
  const { checkoutOpen, closeCheckout } = useUI();
  const { items, subtotal, clearCart }  = useCart();
  const { fmt } = useCurrency();

  const [form, setForm]     = useState({ name:'', phone:'', email:'', address:'', notes:'' });
  const [promo, setPromo]   = useState('');
  const [discount, setDiscount] = useState(0);
  const [promoMsg, setPromoMsg] = useState('');
  const [placing, setPlacing]   = useState(false);

  function onChange(e) { setForm(f => ({ ...f, [e.target.name]: e.target.value })); }

  // async function applyPromo() {
  //   if (!promo) return;
  //   const res = await validatePromo(promo);
  //   if (res.valid) {
  //     const disc = Math.round(subtotal * (res.discount / 100));
  //     setDiscount(disc);
  //     setPromoMsg(`${res.discount}% off applied!`);
  //   } else {
  //     setDiscount(0);
  //     setPromoMsg('Invalid promo code');
  //   }
  // }

  // async function handleOrder() {
  //   if (!form.name || !form.phone) return alert('Please fill Name and Phone');
  //   setPlacing(true);
  //   const total = subtotal - discount;
  //   try {
  //     await placeOrder({
  //       customer: form,
  //       items: items.map(i => ({ id:i.id, name:`${i.brand} ${i.name}`, price:i.price, qty:i.qty })),
  //       subtotal, discount, total, promo_code: promo || null,
  //     });
  //   } catch (_) {}
  //   const waUrl = buildOrderMessage(items, form, promo, discount);
  //   clearCart();
  //   closeCheckout();
  //   window.open(waUrl, '_blank');
  //   setPlacing(false);
  // }
async function applyPromo() {
  if (!promo) return;
  try {
    const res = await validatePromo({ code: promo, items: [], subtotal });

    if (!res.ok) {
      setDiscount(0);
      setPromoMsg('Invalid promo code');
      return;
    }

    const pct = Number(res.discount_pct || 0);

    // If promo is SKU-specific, check cart contains that SKU
    if (res.sku) {
      const matchedItem = items.find(i => i.sku === res.sku);
      if (!matchedItem) {
        setDiscount(0);
        setPromoMsg('This promo code is not valid for items in your cart');
        return;
      }
      // Discount only on that item's total
      const disc = Math.round((matchedItem.price * (matchedItem.qty || 1)) * (pct / 100));
      setDiscount(disc);
      setPromoMsg(`${pct}% off applied on ${matchedItem.brand} ${matchedItem.name}!`);
    } else {
      // General promo — discount on full subtotal
      const disc = Math.round(subtotal * (pct / 100));
      setDiscount(disc);
      setPromoMsg(`${pct}% off applied!`);
    }

  } catch (err) {
    setDiscount(0);
    setPromoMsg(err.message || 'Invalid promo code');
  }
}
//   async function applyPromo() {
//   if (!promo) return;

//   const res = await validatePromo(promo);

//   if (res.ok) {

//     // ✅ Find matching product
//     const matchedItem = items.find(
//       i => i.sku === res.sku
//     );

//     // ❌ Promo not applicable
//     if (!matchedItem) {
//       setDiscount(0);
//       setPromoMsg('This promo code is not valid for selected products');
//       return;
//     }

//     const pct = Number(res.discount_pct || 0);

//     // ✅ Discount only for matched product
//     const productTotal = matchedItem.price * matchedItem.qty;

//     const disc = Math.round(productTotal * (pct / 100));

//     setDiscount(disc);

//     setPromoMsg(`${pct}% off applied on ${matchedItem.name}!`);

//   } else {
//     setDiscount(0);
//     setPromoMsg('Invalid promo code');
//   }
// }


  async function handleOrder() {
    if (!form.name || !form.phone) return alert('Please fill Name and Phone');
    setPlacing(true);
    const total = subtotal - discount;

    // ✅ Generate ref before sending
    const ref = 'ORD-' + Math.random().toString(36).substring(2, 8).toUpperCase();

    try {
      await placeOrder({
        ref,  // ✅ Add this
        customer: form,
        items: items.map(i => ({
          id: i.id,
          name: `${i.brand} ${i.name}`,
          price: i.price,
          qty: i.qty
        })),
        subtotal,
        discount,
        total,
        promo_code: promo || null,
      });
    } catch (_) {}

    const waUrl = buildOrderMessage(items, form, promo, discount);
    clearCart();
    closeCheckout();
    window.open(waUrl, '_blank');
    setPlacing(false);
}

  const total = subtotal - discount;
  const inpStyle = { width:'100%', border:'1px solid var(--grey)', padding:'10px 12px', fontSize:12, outline:'none', fontFamily:'var(--font-body)', color:'var(--dark)', background:'#fafafa', transition:'border-color 0.2s', boxSizing:'border-box' };

  useEffect(() => {
  if (checkoutOpen) {
    const scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  } else {
    const scrollY = parseInt(document.body.style.top || '0') * -1;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    window.scrollTo(0, scrollY);
  }
  return () => {
    const scrollY = parseInt(document.body.style.top || '0') * -1;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    window.scrollTo(0, scrollY);
  };
}, [checkoutOpen]);

  return (
    <>
      {checkoutOpen && <div className="animate-fade-in" onClick={closeCheckout} style={{ position:'fixed', inset:0, background:'rgba(26,26,26,0.5)', zIndex:300 }} />}
      <div style={{
        position:'fixed', top:0, right:0, height:'100%', width:'100%', maxWidth:420,
        background:'#fff', zIndex:301, display:'flex', flexDirection:'column',
        boxShadow:'-8px 0 32px rgba(0,0,0,0.12)',
        transform: checkoutOpen ? 'translateX(0)' : 'translateX(100%)',
        transition:'transform 0.35s cubic-bezier(0.16,1,0.3,1)',
      }}>
        <div style={{ padding:'20px 24px', borderBottom:'1px solid var(--grey)', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <h2 style={{ fontSize:14, fontWeight:600, color:'var(--dark)', letterSpacing:'0.05em' }}>Checkout</h2>
          <button onClick={closeCheckout} style={{ background:'none', border:'none', cursor:'pointer', color:'var(--grey-mid)', padding:4 }}>
            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12"/></svg>
          </button>
        </div>

        <div style={{ flex:1, overflowY:'auto', padding:'20px 24px' }}>
          {/* Summary */}
          <div style={{ background:'var(--cream)', padding:16, marginBottom:20 }}>
            {items.map(i => (
              <div key={i.id} style={{ display:'flex', justifyContent:'space-between', fontSize:12, color:'var(--grey-dark)', marginBottom:6 }}>
                <span>{i.brand} {i.name}{i.qty > 1 ? ` x${i.qty}` : ''}</span>
                <span>{fmt(i.price * i.qty)}</span>
              </div>
            ))}
            {discount > 0 && (
              <div style={{ display:'flex', justifyContent:'space-between', fontSize:12, color:'var(--green)', marginTop:8, paddingTop:8, borderTop:'1px solid var(--grey)' }}>
                <span>Discount</span><span>-{fmt(discount)}</span>
              </div>
            )}
            <div style={{ display:'flex', justifyContent:'space-between', fontSize:13, fontWeight:600, color:'var(--dark)', marginTop:8, paddingTop:8, borderTop:'1px solid var(--grey)' }}>
              <span>Total</span><span>{fmt(total)}</span>
            </div>
          </div>

          {/* Promo */}
          <div style={{ marginBottom:20 }}>
            <label style={{ fontSize:10, letterSpacing:'0.15em', textTransform:'uppercase', color:'var(--grey-dark)', fontWeight:600, display:'block', marginBottom:8 }}>Promo Code</label>
            <div style={{ display:'flex', gap:8 }}>
              <input value={promo} onChange={e => setPromo(e.target.value.toUpperCase())}
                style={{ ...inpStyle, flex:1 }} placeholder="ENTER CODE"
                onFocus={e => e.target.style.borderColor='var(--dark)'}
                onBlur={e => e.target.style.borderColor='var(--grey)'} />
              <button onClick={applyPromo} style={{ padding:'0 16px', background:'var(--dark)', color:'#fff', fontSize:10, letterSpacing:'0.1em', textTransform:'uppercase', fontWeight:700, border:'none', cursor:'pointer', whiteSpace:'nowrap' }}>Apply</button>
            </div>
            {promoMsg && <p style={{ fontSize:11, marginTop:6, color: discount > 0 ? 'var(--green)' : 'var(--red)' }}>{promoMsg}</p>}
          </div>

          {/* Customer */}
          <div>
            <p style={{ fontSize:10, letterSpacing:'0.15em', textTransform:'uppercase', color:'var(--grey-dark)', fontWeight:600, marginBottom:14, paddingTop:8, borderTop:'1px solid var(--grey)' }}>Your Details</p>
            {[
              { name:'name',    label:'Full Name *',      type:'text'  },
              { name:'phone',   label:'Phone Number *',   type:'tel'   },
              { name:'email',   label:'Email',            type:'email' },
              { name:'address', label:'Delivery Address', type:'text'  },
            ].map(({ name, label, type }) => (
              <div key={name} style={{ marginBottom:12 }}>
                <label style={{ fontSize:11, color:'var(--grey-dark)', display:'block', marginBottom:5 }}>{label}</label>
                <input name={name} type={type} value={form[name]} onChange={onChange} style={inpStyle}
                  onFocus={e => e.target.style.borderColor='var(--dark)'}
                  onBlur={e => e.target.style.borderColor='var(--grey)'} />
              </div>
            ))}
            <div style={{ marginBottom:12 }}>
              <label style={{ fontSize:11, color:'var(--grey-dark)', display:'block', marginBottom:5 }}>Notes</label>
              <textarea name="notes" value={form.notes} onChange={onChange} rows={2}
                style={{ ...inpStyle, resize:'vertical' }}
                onFocus={e => e.target.style.borderColor='var(--dark)'}
                onBlur={e => e.target.style.borderColor='var(--grey)'} />
            </div>
          </div>
        </div>

        <div style={{ padding:'20px 24px', borderTop:'1px solid var(--grey)' }}>
          <button onClick={handleOrder} disabled={placing} style={{
            width:'100%', padding:'14px 0', background: placing ? 'var(--grey-mid)' : 'var(--dark)', color:'#fff',
            fontSize:11, letterSpacing:'0.2em', textTransform:'uppercase', fontWeight:700,
            border:'none', cursor: placing ? 'not-allowed' : 'pointer', transition:'background 0.25s',
          }}
            onMouseEnter={e => { if (!placing) e.target.style.background='var(--gold)'; }}
            onMouseLeave={e => { if (!placing) e.target.style.background='var(--dark)'; }}>
            {placing ? 'Placing Order…' : '📱 Order via WhatsApp'}
          </button>
        </div>
      </div>
    </>
  );
}
